import React, { useState } from "react"
import { CompanyAttribute } from "lib/types/generated/graphql-types"
import { Maybe } from "@graphql-tools/utils"
import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"
import { ReactComponent as UpIcon } from "images/icons/chevron-up.svg"
import { ExpandAnimation, NameWrapper } from "./OrderCompany.styled"
import ListEntry from "../Ui/ListEntry"

type Props = {
  company: Maybe<CompanyAttribute> | undefined
}

const OrderCompany = ({ company }: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  if (!company) return null
  return (
    <div>
      <NameWrapper
        tabIndex={0}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <ListEntry label={"Company"} value={company.name || "-"} />
        {isExpanded ? <UpIcon /> : <DownIcon />}
      </NameWrapper>
      {isExpanded && (
        <ExpandAnimation>
          <ListEntry label={"Reg number:"} value={company.registrationNumber || "-"} />
          <ListEntry label={"Tax id:"} value={company.taxId || "-"} />
          <ListEntry label={"Reference:"} value={company.reference || "-"} />
        </ExpandAnimation>
      )}
    </div>
  )
}

export default OrderCompany
